module.exports = __webpack_public_path__ + "img/banner4.8eb676e6.png";